module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Langing-page-w720.1a052c2f.jpg";